// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4487 ? "a4ba8e74" : chunkId) + "." + {"4487":"13c8a32155b33f9b","8210":"cd33abcd3e14fd55"}[chunkId] + ".js";
};